// externals
import type { Reducer } from 'redux';

// libraries
import type { ConsumerInsightsState } from '@makemydeal/dr-dash-types';

// consts/enums
import { CONSUMER_INSIGHTS_FETCH_SUCCESS_V2 } from '../actionTypes/consumerInsightsActionTypes';

export type ConsumerInsightsReducer = Reducer<ConsumerInsightsState>;

export const reducer: ConsumerInsightsReducer = (state: ConsumerInsightsState = {}, action: any) => {
    switch (action.type) {
        case CONSUMER_INSIGHTS_FETCH_SUCCESS_V2: {
            const insights = action.payload?.data?.consumerInsights;
            if (!insights || Object.keys(insights).length === 0) {
                return {
                    preferredDownHigh: undefined,
                    preferredDownLow: undefined,
                    preferredMonthlyHigh: undefined,
                    preferredMonthlyLow: undefined,
                    preferredPriceHigh: undefined,
                    preferredPriceLow: undefined
                };
            }
            return {
                preferredDownHigh: insights.preferredDownPaymentHigh,
                preferredDownLow: insights.preferredDownPaymentLow,
                preferredMonthlyHigh: insights.preferredMonthlyPaymentHigh,
                preferredMonthlyLow: insights.preferredMonthlyPaymentLow,
                preferredPriceHigh: insights.preferredOfferPriceHigh,
                preferredPriceLow: insights.preferredOfferPriceLow
            };
        }
        default: {
            return state;
        }
    }
};
